<template>
	<div class="w-full">
		<div class="mb-6 flex items-center justify-between">
			<div>
				<h1
					class="text-2xl lg:text-3xl font-bold text-text-primary mb-2 tracking-tight"
				>
					Valuation
				</h1>
				<p class="text-sm lg:text-base text-text-secondary">
					Vehicle/property valuation tools and history
				</p>
			</div>
			<div class="text-sm text-text-secondary">
				Selected:
				<strong class="text-text-primary">{{ selectedCount }}</strong>
			</div>
		</div>

		<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
			<valuation-card
				v-for="v in valuers"
				:key="v.id"
				:valuer="v"
				:selected="selectedId === v.id"
				@select="handleSelect"
				@view-progress="openProgressModal"
				@view-summary="handleViewSummary"
			/>
		</div>

		<!-- Reusable modal for showing progress -->
		<modal
			:show="showProgressModal"
			content_class="max-w-xl"
			@input="showProgressModal = $event"
			@update:show="showProgressModal = $event"
			@close="closeProgressModal"
		>
			<template v-slot:content>
				<valuation-progress
					v-if="currentValuer"
					:valuer="currentValuer"
					:status="currentValuer.status"
					:startedDate="currentValuer.startedDate"
					:endDate="currentValuer.endDate"
					@close="closeProgressModal"
					@view-summary="onProgressViewSummary"
				/>
			</template>
		</modal>

		<!-- Reusable modal for showing detailed summary -->
		<modal
			:show="showSummaryModal"
			content_class="max-w-2xl"
			@input="showSummaryModal = $event"
			@update:show="showSummaryModal = $event"
			@close="closeSummaryModal"
		>
			<template v-slot:content>
				<valuation-summary
					v-if="currentValuer"
					:valuer="currentValuer"
					@close="closeSummaryModal"
				/>
			</template>
		</modal>
	</div>
</template>

<script>
import ValuationCard from '../templates/others/valuation-card.vue';
import Modal from '../templates/others/modal.vue';
import ValuationProgress from '../templates/others/valuation-progress.vue';
import ValuationSummary from '../templates/others/valuation-summary.vue';

export default {
	name: 'ValuationPage',
	components: {
		ValuationCard,
		Modal,
		ValuationProgress,
		ValuationSummary,
	},
	data() {
		return {
			valuers: [
				{
					id: 'V-001',
					name: 'James Mwangi',
					areas: ['Nairobi', 'Kisumu', 'Taita'],
					phone: '+254700000001',
					email: 'james.mwangi@example.com',
					status: 'started',
					startedDate: '2025-10-01',
					startedNote:
						'Assigned and awaiting initial site visit and photos.',
					endDate: '',
					summary: 'Assigned to evaluate a mid-range sedan.',
				},
				{
					id: 'V-002',
					name: 'Aisha Odhiambo',
					areas: ['Nairobi', 'Mombasa'],
					phone: '+254700000002',
					email: 'aisha.odhiambo@example.com',
					status: 'processing',
					startedDate: '2025-09-25',
					processingDate: '2025-09-27',
					processingNote:
						'Images submitted; market comparables being collected.',
					endDate: '',
					summary: 'Processing valuation for a residential property.',
				},
				{
					id: 'V-003',
					name: 'Peter Kamau',
					areas: ['Taita', 'Makueni'],
					phone: '+254700000003',
					email: 'peter.kamau@example.com',
					status: 'approved',
					startedDate: '2025-09-10',
					processingDate: '2025-09-12',
					approvedDate: '2025-09-15',
					approvedNote:
						'Valuation reviewed and approved by regional manager.',
					endDate: '',
					summary: 'Approved valuation for commercial vehicle.',
				},
				{
					id: 'V-004',
					name: 'Grace Njeri',
					areas: ['Kisumu', 'Nakuru'],
					phone: '+254700000004',
					email: 'grace.njeri@example.com',
					status: 'completed',
					startedDate: '2025-08-01',
					processingDate: '2025-08-03',
					approvedDate: '2025-08-10',
					endDate: '2025-08-15',
					completedNote:
						'Final report uploaded and dispatched to client.',
					summary:
						'Completed multiple valuations for fleet vehicles.',
				},
			],
			selectedId: null,
			showProgressModal: false,
			showSummaryModal: false,
			currentValuer: null,
			suppressClearCurrent: false,
		};
	},
	computed: {
		selectedCount() {
			return this.selectedId ? 1 : 0;
		},
	},
	methods: {
		handleSelect(valuer) {
			if (this.selectedId === valuer.id) {
				this.selectedId = null;
			} else {
				this.selectedId = valuer.id;
			}
		},
		openProgressModal(valuer) {
			this.currentValuer = valuer;
			this.showProgressModal = true;
		},
		closeProgressModal() {
			this.showProgressModal = false;
			if (!this.suppressClearCurrent) {
				this.currentValuer = null;
			}
		},
		openSummaryModal(valuer) {
			this.currentValuer = valuer;
			this.showSummaryModal = true;
		},
		closeSummaryModal() {
			this.showSummaryModal = false;
			this.currentValuer = null;
		},
		handleViewSummary(valuer) {
			this.openSummaryModal(valuer);
		},
		onProgressViewSummary(valuer) {
			console.log(
				'[valuation] onProgressViewSummary called with valuer:',
				valuer,
			);
			const v = valuer || this.currentValuer;
			this.currentValuer = v;
			this.suppressClearCurrent = true;
			this.showProgressModal = false;
			this.showSummaryModal = true;
			this.$nextTick(() => {
				this.suppressClearCurrent = false;
			});
		},
	},
};
</script>

<style scoped>
/* small spacing rules if needed */
</style>
